<template>
  <div class="navbar-dropdown">
    <navbar-button class="select-button">
      Social Platforms
    </navbar-button>

    <navbar-select
      class="navbar-menu"
      :options="socialSelectOptions"
      :item-class="['navbar-selector']"
    >
      <template v-slot:item="option">
        <template v-if="option.data.id == 'add_account'">
          Add Account
          <navbar-select
            class="navbar-submenu"
            :options="accountTypes"
            @itemSelected="addAccount"
          >
            <template v-slot:item="type">
              {{ type.data.label }}
            </template>
          </navbar-select>
        </template>

        <template v-else>
          {{ option.data.label }}
          <navbar-select
            class="navbar-submenu"
            :options="option.data.accounts"
            @itemSelected="removeAccount(option.data.id, $event)"
          >
            <template v-slot:item="account">
              <div :class="{ unknownAccount: !account.data.sync }">
                <span class="account-name">{{ account.data.label }}</span>
                <span class="accountDel">❌</span>
              </div>
            </template>
          </navbar-select>
        </template>
      </template>
    </navbar-select>
  </div>
</template>

<script>
import NavbarButton from "@/components/navbar/NavbarButton.vue";
import NavbarSelect from "@/components/navbar/NavbarSelect.vue";

import { SOCIAL_LABELS } from "@/api/socials/socials.js";

import { parseObjectToPropsArray } from "@/utils/parsing.js";

// @group Navbar
// Socials dropdown list to add/remove accounts
export default {
  name: "NavbarSocialsDropdown",
  components: {
    NavbarButton,
    NavbarSelect
  },
  props: {
    /** socials with connected account */
    socials: {
      type: Object,
      default: () => new Object()
    }
  },
  data() {
    return {
      /** add account options */
      accountTypes: parseObjectToPropsArray(SOCIAL_LABELS, "label")
    };
  },
  computed: {
    // @vuese
    // Active socials with accounts and add-account feature
    socialSelectOptions() {
      return {
        ...this.socials,
        add_account: { id: "add_account" }
      };
    }
  },
  methods: {
    // @vuese
    // Connect new social account
    // @arg socialId - social name (google/facebook/instagram)
    addAccount(socialId) {
      this.$emit("addAccount", socialId);
    },
    // @vuese
    // Disconnect existing account
    // @arg socialId - social name (google/facebook/instagram) <br>
    // @arg accountId - account ID
    removeAccount(socialId, accountId) {
      this.$emit("removeAccount", { social: socialId, id: accountId });
    }
  }
};
</script>

<style scoped>
.navbar-dropdown .navbar-menu {
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  display: none;

  text-align: start;
}

.select-button {
  box-sizing: border-box;
}

.unknownAccount {
  color: white;
  margin: 0;
}

.unknownAccount:after {
  content: " .";
  animation: dots 1s steps(5, end) infinite;
}

.accountDel {
  margin-left: 5px;
  font-size: 0.8em;
  text-align: right;
}

/** Desktop */
@media only screen and (min-width: 992px) {
  .navbar-dropdown .navbar-menu {
    position: absolute;
    z-index: var(--navbar-dropdown-z);
    width: 150px;
    box-sizing: border-box;
  }
  .navbar-dropdown:hover .navbar-menu {
    display: block;
  }
  .navbar-submenu {
    position: absolute;
    top: -10px;
    left: 150px;

    border: none;

    overflow: hidden;

    width: 0;

    transition: width 0.6s;
  }
  .navbar-selector:hover .navbar-submenu {
    width: 180px;

    border: 1px solid var(--light-grey);
    border-left: none;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    margin: 0 0px 0px -1px;
  }
}

/** Mobile */
@media only screen and (max-width: 991px) {
  .navbar-dropdown {
    display: flex;
    flex-direction: column;
  }
  .navbar-dropdown .navbar-menu {
    width: 100%;
    display: none;
  }
  .navbar-dropdown:hover .navbar-menu {
    display: flex;
    flex-direction: column;
  }
  .navbar-selector:hover .navbar-submenu {
    display: flex;
    flex-direction: column;
  }
  .navbar-submenu {
    background: transparent;
    display: none;
    width: 100%;
  }
}
</style>
